/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetFeatureFlagStatusPathParams = NonNullable<operations['getFeatureFlagStatus']['parameters']['path']>;

export interface Input extends GetFeatureFlagStatusPathParams {
  apiVersion?: string;
}

export async function getFeatureFlagStatus(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/flag-statuses/{projectKey}/{environmentKey}/{featureFlagKey}', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
